var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.component,{tag:"component",attrs:{"action":_vm.action,"mode":_vm.mode,"tasks":_vm.tasks,"isOpened":!!_vm.component},on:{"close":function($event){return _vm.dispatch(null)},"submit":_vm.dispatch}})}
var staticRenderFns = []

export { render, staticRenderFns }